import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  IDetail,
  IEpisodesDetail,
  ISupportLanguage,
} from 'utils/types/storyTypes';
import { theme } from 'utils/style/theme';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import PrimaryButton from 'components/button/PrimaryButton';
import { Trash } from 'iconsax-react';
import InputStyled from 'components/InputStyled';
import SelectStyled from 'components/SelectStyled';
import SelectBox from 'components/SelectBox';

/**
 * * 오토메 - 작품 정보 수정
 */

interface IProps {
  langList: ISupportLanguage[] | null;
  data: IEpisodesDetail | null;
  detailData: IDetail;
  index: number;
  setData: React.Dispatch<React.SetStateAction<IEpisodesDetail | null>>;
}

const EpsiodeContent: React.FC<IProps> = ({
  langList,
  data,
  detailData,
  index,
  setData,
}) => {
  const [title, setTitle] = useState<string>('');
  const [summary, setSummary] = useState<string>('');

  const { t } = useTranslation();

  const setValueForm = () => {
    if (detailData) {
      setTitle(detailData.title);
      setSummary(detailData.summary);
    }
  };

  useEffect(() => {
    setValueForm();
  }, [data]);

  const handleInputChange = (e, type: string) => {
    if (data) {
      const cloneData = JSON.parse(JSON.stringify(data));
      cloneData.details[index][type] = e.target.value;
      setData(cloneData);
    }
  };

  const handleLanguageChange = (e: string) => {
    if (data) {
      const cloneData = JSON.parse(JSON.stringify(data));
      cloneData.details[index]['lang'] = e;
      setData(cloneData);
    }
  };

  const handleRemove = (index: number) => {
    if (data) {
      const cloneData = JSON.parse(JSON.stringify(data));
      cloneData.details.splice(index, 1);
      setData(cloneData);
    }
  };

  return (
    <OtomeProjectContentWrapper>
      <SectionWarpper>
        <p className='title'>{t('updateStory.form.language')}</p>
        <SelectBox
          value={detailData?.lang}
          onChange={(e) => {
            handleLanguageChange(`${e}`);
          }}
          options={langList?.map((v, i) => {
            return {
              value: v.code,
              label: v.code_name,
            };
          })}
        />
      </SectionWarpper>
      <SectionWarpper>
        <p className='title'>{t('updateStory.form.title')}</p>
        <InputStyled
          defaultValue={title}
          onChange={(e) => {
            handleInputChange(e, 'title');
          }}
          maxLength={30}
        />
        <p className='length-subtext'>
          {typeof title?.length === 'number'
            ? `${title?.length}/30 characters`
            : '0/30 characters'}
        </p>
      </SectionWarpper>
      <SectionWarpper>
        <p className='title'>{t('updateStory.form.summary')}</p>
        <TextareaStyled
          defaultValue={summary}
          onChange={(e) => {
            handleInputChange(e, 'summary');
          }}
        />

        <p className='length-subtext'>{summary?.length}/500 characters</p>
      </SectionWarpper>
      {data && data?.details?.length > 1 && (
        <div className='remove'>
          <PrimaryButton
            text='Remove'
            height='40px'
            width='fit-content'
            bgColor='#ffffff'
            textColor={theme.colors.dark_400}
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.gray_6}`}
            rounded='6px'
            hoverBgColor={theme.colors.gray_6}
            activeBgColor={theme.colors.gray_6}
            selectedBgColor={theme.colors.gray_6}
            onClick={() => handleRemove(index)}
            LeftPlaceHolder={<Trash size='24' />}
          />
        </div>
      )}
    </OtomeProjectContentWrapper>
  );
};

export default EpsiodeContent;

const OtomeProjectContentWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
`;

const TextareaStyled = styled.textarea`
  height: 147px;
  background-color: #fff;
  padding: 10px;
  resize: none;
  border: 1px solid ${theme.colors.gray_5};
  border-radius: 0.4rem;
  &:hover {
    border: 1px solid #4096ff;
  }
  /* 스크롤바 전체 */
  &::-webkit-scrollbar {
    width: 0.5rem;
  }
  /* 스크롤 막대 */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
  } /* 스크롤 막대 외부 */
  &::-webkit-scrollbar-track {
    width: 0.6rem;
  }
  &:after {
    font-size: 0.8rem;
    letter-spacing: -0.05rem;
  }
`;
